// @flow
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  setColumnWiseRoutes,
  toggleMenuBarDisplay
} from '../../commons/menuBar/menuBarRedux/menuBarActionCreator';
import {
  toggleSwitchClientDisplay,
  getClientsForSwitchClientOption
} from '../../commons/switchClientDropdown/switchClientDropdownRedux/switchClientDropdownActionCreator';
import { getClients } from '../../commons/clientSearch/clientSearchRedux/clientSearchActionCreator';

import { logout } from '../../../services/authService/authActionCreator';

import MenuBarWrapper from '../../commons/menuBar/menuBarWrapper';
import HeaderBar from '../../commons/headerBar/headerBar';
import SimpleHeader from '../../commons/SimpleHeader';

type Props = {
  // eslint-disable-next-line react/require-default-props
  userProfile: Object,
  setColumnWiseRoutes: Function,
  menuBarState: Object,
  toggleMenuBarDisplay: Function,
  toggleSwitchClientDisplay: Function,
  getClientsForSwitchClientOption: Function,
  getClients: Function,
  logout: Function,
  pageState?: Object,
  history: Object,
  hideHeader?: boolean,
  isRedirectedFromRivigo?: boolean
};

const HeaderWrapper = (props: Props) => {
  if (props.hideHeader) {
    return null;
  }

  if (props.isRedirectedFromRivigo) {
    return <SimpleHeader />;
  }

  return (
    <div className="header_wrapper">
      <HeaderBar
        pageState={props.pageState}
        toggleMenuBarDisplay={props.toggleMenuBarDisplay}
        userProfile={props.userProfile}
        toggleSwitchClientDisplay={props.toggleSwitchClientDisplay}
        getClientsForSwitchClientOption={props.getClientsForSwitchClientOption}
        switchClientDropdownState={props.switchClientDropdownState}
        getClientsFunction={props.getClients}
        logout={props.logout}
      />
      <MenuBarWrapper
        history={props.history}
        userProfile={props.userProfile}
        setColumnWiseRoutes={props.setColumnWiseRoutes}
        menuBarState={props.menuBarState}
        toggleMenuBarDisplay={props.toggleMenuBarDisplay}
        directDeliveryApprovalCount={props.directDeliveryApprovalCount}
      />
    </div>
  );
};

HeaderWrapper.defaultProps = {
  pageState: {
    pageName: '',
    betaPage: false
  }
};

const mapStateToProps = state => ({
  userProfile: state.userProfile,
  menuBarState: state.menuBarState,
  switchClientDropdownState: state.switchClientDropdownState,
  pageState: state.pageState,
  isRedirectedFromRivigo: state.initServiceState.isRedirectedFromRivigo,
  hideHeader: state.initServiceState.hideHeader,
  directDeliveryApprovalCount: state.initServiceState.directDeliveryCount
});

const mapDispatchToProps = dispatch => ({
  setColumnWiseRoutes: bindActionCreators(setColumnWiseRoutes, dispatch),
  toggleMenuBarDisplay: bindActionCreators(toggleMenuBarDisplay, dispatch),
  toggleSwitchClientDisplay: bindActionCreators(
    toggleSwitchClientDisplay,
    dispatch
  ),
  getClientsForSwitchClientOption: bindActionCreators(
    getClientsForSwitchClientOption,
    dispatch
  ),
  getClients: bindActionCreators(getClients, dispatch),
  logout: bindActionCreators(logout, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderWrapper);
